//import React from 'react';
import React, { Component} from 'react';
import {Card,CardText} from 'react-md';
import MathJax from '../../components/react-mathjax-preview';
import AnswerTypeRadiobutton from '../../ui/takeQuiz/AnswerTypeRadiobutton';
import AnswerTypeCheckbox from '../../ui/takeQuiz/AnswerTypeCheckbox';
import AnswerTypeTextbox from '../../ui/takeQuiz/AnswerTypeTextbox';
import AnswerTypeRPTextBox from '../../ui/takeQuiz/AnswerTypeRPTextBox';
import MathParserUtil from '../../lib/math-parser';
import {MQTOptions} from '../../lib/mqt';
import {VectorQuestion,VectorAnswers} from '../../ui/takeQuiz/vectors';
import {createVideoLinkIframe} from '../../common/functions'




//CSS Import
import '../../css/QuestionWithImage.css'
import "../../css/AnswerTypeReasoningChain.css"
import MQTQuestion from './mqt/MQTQuestion'; 
import AnswerTypeReasoningChain from './AnswerTypeReasoningChain';

//const QuestionWithImage = function(this.props) {
    export default class QuestionWithImage extends Component {
        
            constructor(props)
            {
              super(props)
              this.state = {
                shouldRefreshRadioComp:true,
                variableMap:this.props.currentVariableMap,
                mqt_options:{}
              }

              this.onAnswerChoice = this.onAnswerChoice.bind(this);
              this.onAnswerTextbboxHandler = this.onAnswerTextbboxHandler.bind(this);
              this.answersDetailsDisplay = this.answersDetailsDisplay.bind(this);
              //this.onAnswerTextbboxHandler = this.onAnswerTextbboxHandler.bind(this);
              this.refreshShoeList = this.refreshShoeList.bind(this);
             
                         
            } 
     UNSAFE_componentWillMount(){
         console.log('this.props.currentQuestionType',this.props.currentQuestionType);
         
        if(this.props.currentQuestionType === 2){

            this.setState({mqt_options:MQTOptions.CreateMQTFromApi(this.props.mqt_options)});
        }
     }

    UNSAFE_componentWillReceiveProps(nextProps) {
        console.log('this.props.currentQuestionType',nextProps.currentQuestionType);
         
        if(nextProps.currentQuestionType === 2){

            this.setState({mqt_options:MQTOptions.CreateMQTFromApi(nextProps.mqt_options)});
        }
    }
     
     

     onAnswerChoice(value,index){
        // console.log("select Answer is ",value);
        // console.log("select Answer is ",index);
        
        this.props.onAnswerClick(value,index);
        
    
    }

    onMQTAnswerChoice = (value) =>{
        this.props.onAnswerClick(value);
    }

    onAnswerTextbboxHandler(value){
        

        //console.log("evt.target.value  ",evt.target.value);
        this.props.onAnswerEntered(value);

    }
    answersDetailsDisplay(){
        let answerDisplay = null;
        console.log('this.props.currentQuestionType',this.props.currentQuestionType);
        //Display MQT Question Type
        if(this.props.currentQuestionType === 2){
            answerDisplay = <MQTQuestion
                                mqt_options={this.state.mqt_options} 
                                onAnswerChoice={this.onMQTAnswerChoice}
                                questionID={this.props.questionID}
                                showMQTAnswers={this.props.showMQTAnswers}
                                isMobile={this.props.isMobile}
                            />
        }else if(this.props.currentQuestionType === 3){
            if (this.props.answerType === 30) {
                answerDisplay = <AnswerTypeRadiobutton 
                        displayAnswerArr ={this.props.displayAnswerArr} 
                        onAnswerChoice = {this.onAnswerChoice}
                        selectedAnswers = {this.props.selectedAnswers}
                        numOfColumns={this.props.answerDisplayStyle}
                        currentQuestionType={this.props.currentQuestionType}
                        currentVariableMap={this.props.currentVariableMap}
                        isMobile={this.props.isMobile}
                        >
                    </AnswerTypeRadiobutton>
            } else if (this.props.answerType === 40) {
                answerDisplay = <AnswerTypeCheckbox 
                            displayAnswerArr ={this.props.displayAnswerArr} 
                            selectedAnswerArray ={this.props.selectedAnswers} 
                            onAnswerChoice = {this.onAnswerChoice} 
                            numOfColumns={this.props.answerDisplayStyle}   
                            currentQuestionType={this.props.currentQuestionType}
                            currentVariableMap={this.props.currentVariableMap}  
                            isMobile={this.props.isMobile}     
                        >
                    </AnswerTypeCheckbox>
            } else {
                answerDisplay = <VectorAnswers
                                    currentQuestionID = {this.props.questionID}
                                    questionText={this.props.questionText}
                                    onAnswerChoice={this.onMQTAnswerChoice}
                                    answerType={this.props.answerType}
                                    variableMap={this.props.currentVectorVariable}
                                    answers ={this.props.displayAnswerArr}
                                    selectedAnswer = {this.props.selectedAnswers}
                                    vectorSettings={this.props.currentVectorSettings}
                                    showVectorAnswer={this.props.showVectorAnswer}
                                    correctAnswerVectors={this.props.correctAnswerVectors}
                                    vectorAnswerFormulas={this.props.vectorAnswerFormulas}
                                    freeFormVectorOptions={this.props.freeFormVectorOptions}
                                />
            }
        }else if (this.props.currentQuestionType === 4) {
            answerDisplay = <AnswerTypeReasoningChain {...this.props} onReasoningChainFormatChange={this.props.onAnswerEntered} />            
        }else if(this.props.answerType === 0 ){
            // answer type is 0 show radio button
           // this.refreshShoeList();
            answerDisplay = <AnswerTypeRadiobutton 

                    displayAnswerArr ={this.props.displayAnswerArr} 
                    onAnswerChoice = {this.onAnswerChoice}
                    selectedAnswers = {this.props.selectedAnswers}
                    numOfColumns={this.props.answerDisplayStyle}
                    currentQuestionType={this.props.currentQuestionType}
                    currentVariableMap={this.props.currentVariableMap}
                    isMobile={this.props.isMobile}
                    >
                </AnswerTypeRadiobutton> ;

        }else if (this.props.answerType === 1){

            // answer type is 1 show checkbox
            answerDisplay = <AnswerTypeCheckbox 
                    displayAnswerArr ={this.props.displayAnswerArr} 
                    selectedAnswerArray ={this.props.selectedAnswers} 
                    onAnswerChoice = {this.onAnswerChoice} 
                    numOfColumns={this.props.answerDisplayStyle}   
                    currentQuestionType={this.props.currentQuestionType}
                    currentVariableMap={this.props.currentVariableMap}  
                    isMobile={this.props.isMobile}     
                >
            </AnswerTypeCheckbox> 

        }else if(this.props.answerType === 3){
            // answer type is 3 show RP Text Box
            answerDisplay = <AnswerTypeRPTextBox 
            onAnswerChoice = {this.onAnswerTextbboxHandler} 
            currentVariableMap={this.props.currentVariableMap}   
            answer_formula={this.props.answer_formula}    
            showRPAnswer={this.props.showRPAnswer}
            questionID={this.props.questionID}
            answerFormat={this.props.answerDisplayStyle} 
            onSubmit={this.props.onSubmit}
            onAnswerChoiceDetails={this.props.onAnswerChoiceDetails}
            isMobile={this.props.isMobile}
            currentQuestionType={this.props.currentQuestionType}
            >
            </AnswerTypeRPTextBox> 
        }
        else
        {
            answerDisplay = <AnswerTypeTextbox
                key={this.props.questionID}
                onAnswerChoice ={this.onAnswerTextbboxHandler}
                isMobile={this.props.isMobile}
                ></AnswerTypeTextbox>


        }
        return answerDisplay
    }

    refreshShoeList(){

        this.setState({shouldRefreshRadioComp: !this.state.shouldRefreshRadioComp});
    }

    render(){
        let answerResponse = "";
        let classNames = "";




        
        var QuestionContainterAnswerResStyle = {backgroundColor :"white"};
        let answersContentDisplay = null
        console.log("forceUpdateHandler = ",this.props.forceUpdateHandler);
        if(this.props.forceUpdateHandler === true){

            console.log("forceUpdateHandler");
            answersContentDisplay = this.answersDetailsDisplay();
        }else{
            console.log("Else part forceUpdateHandler");
            answersContentDisplay = this.answersDetailsDisplay();
        }

       if(this.props.isCurrentQuestionNonGraded){  
            //No feedback if it is a non-graded question. 
       }
        else if(!this.props.answerCorrect)
        {
            answerResponse  = "Incorrect Answer";
            classNames = "QuestionWithImageTopBar redBackground";
            QuestionContainterAnswerResStyle = {backgroundColor :"rgba(220, 53, 69, 0.25)"};
        }
        else
        {
            answerResponse  = "Correct Answer";
            classNames = "QuestionWithImageTopBar greenBackground";
            QuestionContainterAnswerResStyle = {backgroundColor :"rgba(75, 255, 75, 0.42)"};
            
        }
        let questionAnswerDisplay = null;

              
    return  <Card  className="md-block-centered fullWidth">
                <div style ={this.props.showAnswerResponse && !this.props.showSubmitLoader ? {"display":"block"}: {"display":"none"}} className={classNames}>
                    <span>{answerResponse}</span>
                </div>
               {/* <CardTitle className="QuestionWithImageTitle" style={this.props.showAnswerResponse ? QuestionContainterAnswerResStyle: {backgroundColor :"white"}} title={this.props.title} >
                </CardTitle>*/}
                <CardText className="QuestionWithImageContainter" style={this.props.showAnswerResponse && !this.props.showSubmitLoader ? QuestionContainterAnswerResStyle: {backgroundColor :"white"}}>
                   {// <img  src={this.props.questionImage} alt='1' className="QuestionWithImage-Img"/>
                    //<p>{this.props.imageCaption}</p>}
                   }{this.props.currentQuestionType === 3?
                    <VectorQuestion
                    questionText={this.props.questionText}
                    variableMap={this.props.currentVectorVariable}
                    vectorSettings={this.props.currentVectorSettings}
                    vectorBelowQuestionText={this.props.vectorBelowQuestionText}
                    answers ={this.props.displayAnswerArr}
                    answerType={this.props.answerType}
                  />
                  : <MathJax math={MathParserUtil.setVariablesToText(this.props.questionText,this.props.currentVariableMap)} />
                   }
                   
                    
                    {this.props.questionText !== null ? createVideoLinkIframe(this.props.questionText):''//<TextField id="answerBox" fullWidth={false} onChange={this.props.onAnswerEntered}/>
                    } 
                    {questionAnswerDisplay}

                    {answersContentDisplay}
                    
                </CardText>
                <div style ={this.props.showAnswerResponse && !this.props.showSubmitLoader ? {"display":"block"}: {"display":"none"}} className={classNames}>
                    <span>{answerResponse}</span>
                </div>
                
            </Card>
};

// QuestionWithImage.propTypes = {
//     title: PropTypes.string.isRequired,
//     questionImage: PropTypes.any,
//     imageCaption:PropTypes.string.isRequired,
//     questionText:PropTypes.string.isRequired,
//     onAnswerEntered:PropTypes.func.isRequired,
// }
    
    }


